module.exports = __webpack_public_path__ + "../resources/img/error_icon.e0372d61.png";